import TileGridContainer from 'features/tiles/tileGridContainer';
import { FC } from 'react';
import TileWithoutDefaultStyling from 'features/tiles/tileWithoutDefaultStyling';
import { UploadRevenues } from 'features/upload/revenue/upload-revenues';
import { UploadOpportunities } from 'features/upload/opportunity/upload-opportunities';

export const SettingsUploadPage: FC = () => {
  return (
    <TileGridContainer>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full grow basis-full">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 pb-2 mb-4 mt-2 border-b border-neutral-200">
            Revenue CSV
          </h2>
          <UploadRevenues />
        </section>
      </TileWithoutDefaultStyling>

      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full grow basis-full mt-3">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 pb-2 mb-4 mt-2 border-b border-neutral-200">
            Opportunity CSV
          </h2>
          <UploadOpportunities />
        </section>
      </TileWithoutDefaultStyling>
    </TileGridContainer>
  );
};
